module.exports = __webpack_public_path__ + "img/kangfuyongpin_shrz.8d1222b5.png";